var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ob1-message-alerte", {
        attrs: {
          "data-testid": "eligibility-info-alert",
          "is-simple-alerte":
            _vm.eligibilityInfos.eligibilityMessage.simpleAlert,
          type: _vm.formattedType,
          title: _vm.eligibilityInfos.eligibilityMessage.title,
          texts: _vm.eligibilityInfos.eligibilityMessage.texts,
          "with-arrow-link": _vm.withArrowLink,
          "link-href": _vm.linkHref,
          target: _vm.linkTarget,
          "data-toggle": _vm.linkDataToggle,
          "link-label": _vm.linkText,
          "with-button-from-dto": _vm.buttonFromDto,
        },
      }),
      _vm._v(" "),
      _vm.eligibilityInfos.fiberPopin
        ? _c(
            "section",
            [
              _c(
                "ob1-popin-modal",
                {
                  attrs: {
                    "data-testid": "eligibility-info-fiber-popin",
                    "popin-modal-dto":
                      _vm.eligibilityInfos.fiberPopin.popinModal,
                  },
                },
                [
                  _c("FiberPopin", {
                    attrs: { dto: _vm.eligibilityInfos.fiberPopin },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfos.pifInfos
        ? _c(
            "section",
            [
              _c("PifInfos", {
                attrs: {
                  "data-testid": "eligibility-info-pif",
                  "pif-infos": _vm.eligibilityInfos.pifInfos,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfos.pifXgsponInfos
        ? _c(
            "section",
            [
              _c("PifXgsponInfos", {
                attrs: {
                  "data-testid": "eligibility-info-pif-xgspon",
                  "pif-xgspon-infos": _vm.eligibilityInfos.pifXgsponInfos,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }